$(document).ready(function () {
  if ($('.frame').data('page') == 'about') {
    // aboutBanner
    const aboutBannerAni = gsap.timeline();
    const filaments = document.querySelectorAll(".filament");
    filaments.forEach((path) => {
      const length = path.getTotalLength();
      gsap.set(path, { strokeDasharray: length, strokeDashoffset: length });
    });
    aboutBannerAni
      .from("#about-paper", { duration: 0.5, scale: 0, ease: 'circ.out' })
      .from("#about-rect", { duration: 0.5, scale: 0, ease: 'circ.out' })
      .from(".about-hand-img", { delay: 0.1, duration: 0.5, y: 400, x: 0, ease: 'circ.out' })
      .to(".filament-right", { duration: 0.3, strokeDashoffset: 0, ease: "power1.inOut" })
      .to(".filament-left", { duration: 0.5, strokeDashoffset: 0, ease: "power1.inOut" })
      .to("#light-filament", { duration: 1, filter: "drop-shadow(0 0 15px rgba(255, 255, 255, 0.8))", ease: "sine.inOut" }, "-=0.5")
      .from(".showcase_bn_arrow", { delay: 0.5, duration: 0.5, opacity: 0, y: -20, stagger: 0.5, repeat: -1, repeatDelay: 3, })

    
    let mm = gsap.matchMedia();
    mm.add("(max-width: 1024px)", () => {

      // aboutFeature
      let aboutFeature_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#aboutFeature",
          start: "top 50%",
        }
      });
      aboutFeature_tl
        .from(".item-website .feature-item-inner", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".item-ai .feature-item-inner", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".item-geo .feature-item-inner", { duration: 0.5, scale: 0, ease: 'circ.out' })
    });

    mm.add("(min-width: 1025px)", () => {
      
      // aboutFeature
      let aboutFeature_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#aboutFeature",
          start: "top 10%",
          end: "+=1000",
          scrub: 1,
          pin: true,
          anticipatePin: 1,
        }
      });
      gsap.set(".dash-circle", { transformOrigin: "center center" });
      const maskPaths = document.querySelectorAll(".dash-line-mask");
      maskPaths.forEach((path) => {
        const length = path.getTotalLength();
        gsap.set(path, { strokeDasharray: length, strokeDashoffset: length });
      });
      aboutFeature_tl
        .from(".item-website .dash-circle", { duration: 0.5, scale: 0, ease: "back.out(1.7)" })
        .to(".item-website .dash-line-mask", { duration: 0.8, strokeDashoffset: 0, ease: "power2.inOut" }, "-=0.2")
        .from(".item-website .feature-item-inner", { delay: 0.1, duration: 0.5, scale: 0, ease: 'back.out(1.7)' }, "-=0.2")
        .from(".item-ai .dash-circle", { duration: 0.5, scale: 0, ease: "back.out(1.7)" })
        .to(".item-ai .dash-line-mask", { duration: 0.8, strokeDashoffset: 0, ease: "power2.inOut" }, "-=0.2")
        .from(".item-ai .feature-item-inner", { delay: 0.1, duration: 0.5, scale: 0, ease: 'back.out(1.7)' }, "-=0.2")
        .from(".item-geo .dash-circle", { duration: 0.5, scale: 0, ease: "back.out(1.7)" })
        .to(".item-geo .dash-line-mask", { duration: 0.8, strokeDashoffset: 0, ease: "power2.inOut" }, "-=0.2")
        .from(".item-geo .feature-item-inner", { delay: 0.1, duration: 0.5, scale: 0, ease: 'back.out(1.7)' }, "-=0.2");

    });

    // All media width
    mm.add("all", () => {

      // aboutMission
      let aboutMission_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#aboutMission",
          start: "top center",
          end: "bottom 90%",
          scrub: 1,
          // markers: true,
        }
      });
      aboutMission_tl
        .to(".about-mission-bg", { scale: 1.5 })
 
      
      // aboutWhyDo - sean img
      let aboutWhyDo_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#aboutWhyDo .about-intro-img",
          start: "top 50%",
        }
      });
      gsap.set("#cianwang-logo", { transformOrigin: "right bottom" });
      gsap.set(".rect-blue", { transformOrigin: "center center" });
      gsap.set(".rect-white", { transformOrigin: "center center" });
      aboutWhyDo_tl
        .from("#cianwang-logo", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".rect-white", { duration: 0.5, scale: 0, ease: 'circ.out' }, "-=0.2")
        .from(".rect-blue", { duration: 0.2, scale: 0, ease: 'circ.out' })
        .from(".about-intro-hand-img", { delay: 0.3, duration: 0.5, y: 800, x: 0, ease: 'circ.out' })
        .from(".info-card-2-img", { duration: 0.5, opacity: 0, y: 40, ease: 'circ.out' })
        .from(".info-card-1-img", { duration: 0.5, opacity: 0, y: 50, ease: 'circ.out' }, "-=0.2")
        .from(".search-bar-img", { duration: 0.3, scale: 0, ease: 'circ.out' }, "-=0.2")
        .from(".geo-pill-img", { duration: 0.3, scale: 0, ease: 'circ.out' }, "-=0.2")
        .from(".seo-pill-img", { duration: 0.3, scale: 0, ease: 'circ.out' }, "-=0.1")


      // aboutJourney - Step 1
      let aboutJourney_tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-1",
          start: "top 50%",
        }
      });
      aboutJourney_tl
        .from(".steps-item-wrap.step-1 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-1 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
        .from(".steps-item-wrap.step-1 .arrow-down", { duration: 0.3, opacity: 0, y: -5, stagger: 0.1 })

      // aboutJourney - Step 2
      let aboutJourney_t2 = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-2",
          start: "top 50%",
        }
      });
      aboutJourney_t2
        .from(".steps-item-wrap.step-2 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-2 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
        .from(".steps-item-wrap.step-2 .arrow-down", { duration: 0.3, opacity: 0, y: -5, stagger: 0.1 })

      // aboutJourney - Step 3
      let aboutJourney_t3 = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-3",
          start: "top 50%",
        }
      });
      aboutJourney_t3
        .from(".steps-item-wrap.step-3 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-3 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
        .from(".steps-item-wrap.step-3 .arrow-down", { duration: 0.3, opacity: 0, y: -5, stagger: 0.1 })

      // aboutJourney - Step 4
      let aboutJourney_t4 = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-4",
          start: "top 50%",
        }
      });
      aboutJourney_t4
        .from(".steps-item-wrap.step-4 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-4 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
        .from(".steps-item-wrap.step-4 .arrow-down", { duration: 0.3, opacity: 0, y: -5, stagger: 0.1 })

      // aboutJourney - Step 5
      let aboutJourney_t5 = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-5",
          start: "top 50%",
        }
      });
      aboutJourney_t5
        .from(".steps-item-wrap.step-5 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-5 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")

    });





    // about partners
    let partnersSlider = null;

    // 初始化或重建 Swiper
    function initPartnersSlider() {
      const swiperWrapper = document.querySelector('#partnersSlider .swiper-wrapper');
      const slides = swiperWrapper.querySelectorAll('.swiper-slide:not(.is-empty)');
      const totalSlides = slides.length;

      // 根據螢幕寬度判斷每頁要多少個項目
      const perView = window.innerWidth >= 801 ? 5 : 3; // 欄數
      const rows = window.innerWidth >= 801 ? 5 : 8;  // 列數
      const perPage = perView * rows;

      // 清除舊的空白 slide
      swiperWrapper.querySelectorAll('.is-empty').forEach(e => e.remove());
      // 插入空白 slide，防止 Swiper grid 對不足一頁的項目自動填充導致順序錯亂
      const remainder = totalSlides % perPage;
      const emptyCount = remainder === 0 ? 0 : perPage - remainder;
      for (let i = 0; i < emptyCount; i++) {
        const emptySlide = document.createElement('div');
        emptySlide.className = 'swiper-slide is-empty';
        swiperWrapper.appendChild(emptySlide);
      }

      // 如果已有 Swiper 實例，銷毀重建
      if (partnersSlider) partnersSlider.destroy(true, true);

      // 初始化 swiper
      partnersSlider = new Swiper('#partnersSlider', {    
        slidesPerView: perView,  // 每列 n 張圖
        grid: {
          rows: rows,  // 每頁 n 列
          fill: 'row',  // 橫向填滿
        },
        slidesPerGroup: perView, // 一次切換 1 整頁（=n列）
        spaceBetween: 0,  // 圖片之間間距
        loop: false,  // 禁止循環，不然會錯亂
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // 根據螢幕大小調整排版 (min-width)
        breakpoints: {
          801: { slidesPerView: 5, grid: { rows: 5, fill: 'row' }, slidesPerGroup: 5 },
          0: { slidesPerView: 3, grid: { rows: 8, fill: 'row' }, slidesPerGroup: 3 },
        },
      });
    }
    // 如果頁面上有 partnersSlider
    if ($('#partnersSlider').length > 0) {
      initPartnersSlider(); // 初始載入 swiper
    }
    // resize 時自動重建
    let currentMode = window.innerWidth >= 801 ? 'desktop' : 'mobile';
    let aboutResizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(aboutResizeTimer);
      aboutResizeTimer = setTimeout(function() {
        let newMode = window.innerWidth >= 801 ? 'desktop' : 'mobile';
        // 只有模式切換時才重建
        if (newMode !== currentMode) {
          // 如果頁面上有 partnersSlider
          if ($('#partnersSlider').length > 0) {
            initPartnersSlider(); // 重建 Swiper
          }
          currentMode = newMode;
        }
      }, 300);
    });
  }
});
